import { Component } from '@angular/core';
import { Router }    from '@angular/router';

import { UserService } from '@services/user.service';


@Component({
 selector:    'red-institutional',
 templateUrl: './home.component.html',
 styleUrls:   [ './home.component.scss' ]
})
export class HomeComponent {

  constructor(
    private router:      Router,
    private userService: UserService,
  ) { }

  public openSignUpOverlay(event?: Event) {

    if (event) event.preventDefault();

    if (this.userService.isLoggedIn()) {
      this.router.navigate(this.userService.redirectRoute, {
        queryParams: { entrar: null }
      }).then();
      return;
    }

    this.router.navigate(['/home'], {
      queryParams: { entrar: true }
    }).then();
  }

}
